import React, { useEffect, useRef, useState } from "react";

import axios, { Axios } from "axios";
import { GetRamaLogs } from "../../../api/api";
import { SkeletonCard } from "../../../context/Customfunction";

function RamaLogs() {
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState([]);
  //console.log("eventData", eventData);
  const intervalRef = useRef(null);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await GetRamaLogs(selectedDate);
      if (data?.data?.status === true) {
        //console.log("data?.data?.data", data?.data?.data);
        setEventData(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    intervalRef.current = setInterval(() => {
      fetchData();
    }, 10000);

    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedDate]);

  const cameraCards = [
    {
      label: "Rama-University Camera",
      // image: "https://visionemptrack.greymatterz.com/stream/cam22",
      image: "https://visionemptrack.greymatterz.com/person_count/video_feed",
    },
  ];

  const handleReset = async () => {
    try {
      const data = axios.post(
        "https://visionemptrack.greymatterz.com/person_count/reset_counts",
        {
          camera_url:
            "rtsp://test:admin123098@103.221.77.7:554/Streaming/Channels/1501/",
        }
      );

      //console.log("data", data);
      if (data) {
        fetchData();
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  return (
    <div className="d-flex fullHeightCst">
      {/* LEFT SECTION */}
      <div className="leftSection">
        <div className="titleFiltrer d-flex align-items-center justify-content-between p-4 border-bottom bg-white">
          <div>
            <h2 className="mb-0">Camera Logs</h2>
          </div>
          <div className="ms-auto">
            <button onClick={handleReset} className="mainBlue2 py-2 px-4">
              Reset
            </button>
          </div>
        </div>

        <div className="p-4">
          <h5 className="mb-3">Entrance Camera Group</h5>
          <div className="cameraGrid">
            {cameraCards.map((cam, idx) => (
              <div key={idx} className="image-box bg-white">
                <img
                  src={cam.image}
                  alt={cam.label}
                  className="img-fluid"
                  // style={{ height: "200px", objectFit: "cover", width: "100%" }}
                />
                <div className="text-center py-2">{cam.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="rightSection bg-white border-start">
        <div className="titleFiltrer d-flex align-items-center justify-content-between p-4 border-bottom bg-white">
          <h2>Details</h2>
          {!loading && eventData.length > 0 && (
            <div className="text-end">
              <div>
                Total Check-ins:{" "}
                <strong>
                  {eventData.reduce(
                    (sum, user) => sum + (user.no_of_checkin || 0),
                    0
                  )}
                </strong>
              </div>
              <div>
                Total Check-outs:{" "}
                <strong>
                  {eventData.reduce(
                    (sum, user) => sum + (user.no_of_checkout || 0),
                    0
                  )}
                </strong>
              </div>
            </div>
          )}
        </div>

        <div className="px-3 my-3 cstHeighRight">
          {loading ? (
            Array.from({ length: 5 }).map((_, i) => <SkeletonCard key={i} />)
          ) : (
            <table className="table cstTable table-sm mb-0">
              <thead className="sticky-top" style={{ top: 0, zIndex: 1 }}>
                <tr>
                  <td>Image</td>
                </tr>
              </thead>
              <tbody>
                {eventData.map((user, idx) => {
                  const validImages = (user.image_path || []).filter(
                    (img) => img && img !== "skipped"
                  );
                  //console.log("validImages", validImages);
                  return validImages.map((imgPath, imgIdx) => (
                    <tr key={`${idx}-${imgIdx}`}>
                      <td>
                        <div className="d-flex align-items-center gap-3">
                          <span>
                            <strong>Image {imgIdx}</strong>
                          </span>
                          <img
                            src={`https://visionemptrack.greymatterz.com/person_count/${imgPath}`}
                            alt={`Snapshot ${imgIdx}`}
                            onClick={() =>
                              setZoomedImage(
                                `https://visionemptrack.greymatterz.com/person_count/${imgPath}`
                              )
                            }
                            className="rounded"
                            style={{
                              width: "75px",
                              height: "75px",
                              objectFit: "cover",
                              cursor: "zoom-in",
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {zoomedImage && (
        <div
          className="zoomed-image-overlay"
          onClick={() => setZoomedImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={zoomedImage}
            alt="Zoomed"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 20px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}
    </div>
  );
}

export default RamaLogs;
